import React from "react";

const tarihselDonemler = [
  {
    id: 1,
    donem: "Antik Dönem",
    tarih: "M.Ö. 756 – M.S. 395",
    renk: "brand-gold",
    gorsel: "/images/tarihce/antik2.webp",
    gorselAlt: "Uzungöl — Trabzon",
    icerik: [
      "Trabzon adı, eski Yunanca'da masa ya da yamuk biçimi anlamına gelen \"trapezos\" kelimesinden gelmektedir. Kent merkezi kuzeyde denizden, güneyde Boztepe'nin üzerine kadar düzgün olmayan teraslar halinde yükselir. Değirmendere, Kuzgundere ve Zağnos dereleri yerleşimi derin boğazlarla bölmüştür.",
      "Trabzon adına \"Trapezos\" olarak ilk kez, Yunanlı komutan Ksenophon tarafından kaleme alınan M.Ö. 4. yüzyılda geçen olayların anlatıldığı \"Anabasis\" adlı antik kaynakta rastlanmaktadır. İyon kökenli Miletoslular M.Ö. 7. yüzyılda Karadeniz kıyılarında koloni kentleri kurmuş; Trabzon da bu koloniler arasında sayılmaktadır.",
      "M.Ö. 66 yılında Roma yönetimine giren Trabzon, İmparator Hadrian döneminde (117–138) büyük bir imar atılımı yaşadı; liman, su kemerleri ve dini yapılar inşa edildi. 395 yılında Roma İmparatorluğu ikiye ayrılınca şehir, merkezi İstanbul olan Doğu Roma / Bizans İmparatorluğu sınırları içinde kaldı.",
    ],
  },
  {
    id: 2,
    donem: "Bizans & Komnenos Dönemi",
    tarih: "1204 – 1461",
    renk: "brand-blue",
    gorsel: "/images/tarihce/Hagia_Sophia_Trabzon.jpg",
    gorselAlt: "Trabzon Ayasofyası",
    icerik: [
      "Bizans İmparatorluğu'nun 1204'te IV. Haçlı Seferleri'yle Latin işgaline uğraması üzerine, imparator I. Andronikos Komnenos'un torunları Aleksios ve David, Gürcü Kraliçesi Tamara'nın da yardımıyla Trabzon'da bağımsız Komnenos Krallığı'nı kurdular.",
      "Anadolu Selçukluları ile evlilik bağı kurarak ve vergi ödeyerek siyasi varlığını sürdüren Komnenos Krallığı, I. Manuel Komnenos zamanında (1238–1265) en parlak dönemini yaşadı. Gümüşhane'deki gümüş madenlerinin etkisiyle ekonomik açıdan da güçlenen şehir, dönemin önemli ticaret merkezlerinden biri hâline geldi.",
      "I. Bayezid'in 1398'de Samsun yöresini almasından sonra Trabzon Osmanlı Devleti'ne yıllık vergi ödemek zorunda bırakıldı. Son hükümdar David Komnenos (1458–1461) vergi ödemeyi durdurarak Osmanlılara karşı Avrupa devletleriyle ittifak arayışına girdi; bu gelişme Trabzon'un fethini kaçınılmaz kıldı.",
    ],
  },
  {
    id: 3,
    donem: "Osmanlı Fethi",
    tarih: "15 Ağustos 1461",
    renk: "brand-bordo",
    gorsel: "/images/tarihce/Trebizond_fortifications_1875.jpg",
    gorselAlt: "Trabzon Kalesi Surları — 1875",
    icerik: [
      "Fatih Sultan Mehmet, 1453'te İstanbul'u fethederek Bizans İmparatorluğu'na son verdikten sonra, doğu sınırlarını güvence altına almak amacıyla Trabzon'un fethini zorunlu gördü. Donanma ve kara ordusuyla harekete geçen Osmanlı kuvvetleri, bizzat Fatih'in komutasında Komnenos Krallığı'nın başkenti Trabzon'u kuşattı.",
      "Uzun süre dayanamayan şehir 1461'de teslim oldu; böylece Trabzon Osmanlı hâkimiyetine girdi. Fatih, birkaç gün şehirde kaldıktan sonra Kazım Bey'i Trabzon valiliğine atayarak kentten ayrıldı. Trabzon, II. Bayezid'in oğlu Yavuz Sultan Selim'in sancak beyi olarak atanmasından sonra \"şehzade şehri\" unvanını kazandı.",
      "1487 yılında Yavuz Sultan Selim'in vali olarak atanmasıyla kentte imar faaliyetleri hız kazandı ve 1515'te annesi Gülbahar Hatun adına Hatuniye Camii ve külliyesi yapıldı. Bu dönemde Trabzon, hem siyasi hem de kültürel açıdan büyük bir dönüşüm geçirdi.",
    ],
  },
  {
    id: 4,
    donem: "Kanuni Sultan Süleyman'ın Doğduğu Şehir",
    tarih: "1495",
    renk: "brand-gold",
    gorsel: "/images/tarihce/Kanuni_Evi.jpg",
    gorselAlt: "Kanuni Sultan Süleyman'ın Trabzon'daki Evi",
    icerik: [
      "Osmanlı İmparatorluğu'nu hemen her açıdan zirveye taşıyan, Batılılarca \"Muhteşem Süleyman\" olarak adlandırılan Kanuni Sultan Süleyman 1495'te Trabzon'da doğdu. 15 yaşına kadar çocukluğunu Trabzon'da geçiren Kanuni, ilk eğitimini de bu şehirde aldı.",
      "Kanuni'nin padişah olmasından sonra Trabzon, Batum ile birleştirilerek eyalet merkezi hâline getirildi. Şehir bu dönemde Karadeniz ticaretinin en önemli durağı olma özelliğini korudu; Doğu ile Batı arasındaki ipek ve baharat yollarının kilit noktasıydı.",
      "1867 yılında Trabzon'da büyük bir yangın çıkmış, pek çok kamu binası bu sırada yanmış ve şehir daha sonra yeniden düzenlenmiştir. 1868 yılında vilayet olan Trabzon'a merkez sancağı dışında Lazistan, Gümüşhane ve Canik sancakları da bağlandı.",
    ],
  },
  {
    id: 5,
    donem: "Birinci Dünya Savaşı & Kurtuluş Savaşı",
    tarih: "1916 – 1918",
    renk: "brand-blue",
    gorsel: "/images/tarihce/ww1.jpg",
    gorselAlt: "Tarihi Trabzon",
    icerik: [
      "Birinci Dünya Savaşı'nın en ağır darbesini gören illerden biri olan Trabzon, Rus donanmasının 17 Kasım 1914'te gerçekleştirdiği bombardımanla büyük yıkıma uğradı. 8 ve 11 Şubat 1915 bombardımanlarında 1.000'den fazla insan hayatını kaybetti. Ruslar 14 Nisan 1916'da Trabzon'a girdi; şehrin acı dolu esaret ve sürgün günleri başladı.",
      "Rusların işgali altında geçen yaklaşık iki yıl boyunca Müslüman halka ağır baskılar uygulandı; değerli kültür ve sanat eserleri sandık sandık Rusya'ya taşındı. Türk matbaalarından yararlanılarak Rusça \"Trabzon Askerî Gazetesi\" yayımlandı. Bu dönemin en büyük kaybı, Rusların vilayet arşivini tamamen imha etmesi oldu.",
      "1917'de Rusya'da Bolşevik İhtilali patlak verince Rus ordusu geri çekilmek zorunda kaldı. 11 Şubat 1918'de genel harekat emrini alan Türk kuvvetleri, Trabzonlu Albay Hamdi Bey (Pirselimoğlu) komutasındaki 37. Tümen ile birlikte ilerledi. 14 Şubat'ta Vakfıkebir, 17 Şubat'ta Akçaabat geri alındı ve 24 Şubat 1918'de Trabzon'a girildi. Trabzon'un yaklaşık iki yıllık esareti sona erdi.",
    ],
  },
  {
    id: 6,
    donem: "Atatürk'ün Trabzon Ziyaretleri",
    tarih: "1924 – 1937",
    renk: "brand-bordo",
    gorsel: "/images/tarihce/AtaturkveTrabzon_TurkOcagiBinasindanCikarken.jpg",
    gorselAlt: "Atatürk Trabzon'da — Türk Ocağı Binasından Çıkarken",
    icerik: [
      "Cumhuriyet'in kurucusu Mustafa Kemal Atatürk, Trabzon'u 1924, 1930 ve 1937 olmak üzere üç kez ziyaret etti. İlk ziyaret tarihi olan 15 Eylül 1924, Trabzonlularca \"Atatürk Günü\" olarak benimsendi ve bu duygu kendisine bir telgrafla bildirildi.",
      "Atatürk'ün ziyaretleri, şehrin Cumhuriyet dönemindeki kalkınma atılımlarına büyük ivme kazandırdı. Her ziyarette halkla buluşan, sorunları dinleyen Atatürk; eğitim, ticaret ve altyapı alanlarında Trabzon'un gelişimine doğrudan katkı sağladı.",
      "Günümüzde 4.000 yıllık köklü tarihiyle Trabzon; Roma ve Bizans dönemlerini yaşayan, Fatih Sultan Mehmet'in fethetttiği, Yavuz Sultan Selim'in valilik yaptığı, Kanuni Sultan Süleyman'ın doğduğu ve Atatürk'ün üç kez ziyaret ettiği eşsiz bir şehir olma özelliğini korumaktadır.",
    ],
  },
  {
    id: 7,
    donem: "Trabzon'da Açıklanan Büyük Emanet",
    tarih: "1937",
    renk: "brand-gold",
    gorsel: "/images/tarihce/ataturk1937.jpg",
    gorselAlt: "Atatürk — Trabzon 3. Ziyaret 1937",
    icerik: [
      "Bazen bir şehir, tarihin en büyük anlarına yalnızca tanıklık etmez; o anın anlamını da derinleştirir. Trabzon, işte böyle bir şehirdir. 1937 yılında Gazi Mustafa Kemal Atatürk, milletine duyduğu güveni ve bağlılığı, mal varlığını millete bağışlama iradesini Trabzon'da ortaya koyarak tarihe unutulmaz bir iz bırakmıştır.",
      "Atatürk bu anlamlı açıklamayı, Trabzonluların kendisine hediye ettiği Soğuksu'daki köşkte yapmıştır. Yani milletin sevgisiyle kendisine sunulan bir mekânda, yine milletine dönmek üzere bir emaneti teslim etmiştir. \"Bana verilen yine milletime aittir\" anlayışının en zarif ve en yüksek ifadesi olarak tarihe geçen bu irade; sevginin, vefanın ve karşılıklı güvenin sembolü hâline gelmiştir.",
      "Bu ziyaret, Atatürk'ün sağlığının eskisi kadar güçlü olmadığı bir dönemde gerçekleşmiştir. Bedeninin yorgunluğuna rağmen milletinden uzak durmamış; halkla buluşmayı, ülkenin durumunu yerinde görmeyi ve tarihî sorumluluklarını yerine getirmeyi sürdürmüştür. Trabzon'da açıklanan bu büyük emanet hâlâ aynı kuvvetle yüreklere dokunmaktadır: Servetin gerçek anlamı sahip olmakta değil, millete hizmette gizlidir.",
    ],
  },
];

const colorMap: Record<string, string> = {
  "brand-gold": "#D4A017",
  "brand-blue": "#0F4C81",
  "brand-bordo": "#4E0F26",
};

const TrabzonTarihiPage: React.FC = () => (
  <div className="min-h-screen bg-bg-page">

    {/* Hero */}
    <div
      className="relative py-20 text-white overflow-hidden"
      style={{ background: "linear-gradient(135deg, #0F172A 0%, #0F4C81 60%, #4E0F26 100%)" }}
    >
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "url('/images/tarihce/ww1.jpg')", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(15,23,42,0.9) 0%, rgba(15,76,129,0.8) 60%, rgba(78,15,38,0.85) 100%)" }} />
      <div className="relative z-10 w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-widest mb-3">
          Tarihçe ve Hafıza
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
          Trabzon'un <span style={{ color: "#D4A017" }}>Tarihi</span>
        </h1>
        <p className="text-white/75 max-w-2xl mx-auto leading-relaxed text-lg">
          Roma'dan Bizans'a, Komnenos'tan Osmanlı'ya — 4.000 yıllık köklü bir medeniyetin izleri.
        </p>
        <div className="flex flex-wrap justify-center gap-6 mt-8 text-sm">
          {[
            { sayi: "4.000+", etiket: "Yıllık Tarih" },
            { sayi: "3", etiket: "Büyük Medeniyet" },
            { sayi: "1461", etiket: "Osmanlı Fethi" },
            { sayi: "1918", etiket: "Kurtuluş Yılı" },
          ].map((s) => (
            <div key={s.etiket} className="text-center">
              <div className="text-2xl font-extrabold" style={{ color: "#D4A017" }}>{s.sayi}</div>
              <div className="text-white/50 text-xs uppercase tracking-wider mt-0.5">{s.etiket}</div>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Dönemler */}
    <section className="py-20 bg-bg-page">
      <div className="w-full px-6 xl:px-16">
        <div className="space-y-16 max-w-6xl mx-auto">
          {tarihselDonemler.map((donem) => (
            <div key={donem.id} className="grid md:grid-cols-2 gap-10 items-center">
              {/* Görsel */}
              <div className="relative rounded-2xl overflow-hidden shadow-xl group">
                <img
                  src={donem.gorsel}
                  alt={donem.gorselAlt}
                  className="w-full h-72 object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = `https://picsum.photos/seed/${donem.id}trabzon/800/500`;
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-3 right-3 text-white/50 text-[10px]">© Wikimedia Commons</div>
              </div>

              {/* İçerik */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <span className="text-xs font-bold px-3 py-1.5 rounded-full text-white"
                    style={{ backgroundColor: colorMap[donem.renk] }}>
                    {donem.tarih}
                  </span>
                </div>
                <h3 className="text-2xl font-extrabold mb-4 leading-tight"
                  style={{ color: colorMap[donem.renk] }}>
                  {donem.donem}
                </h3>
                <div className="space-y-3">
                  {donem.icerik.map((paragraf, j) => (
                    <p key={j} className="text-text-muted text-sm leading-relaxed text-justify">{paragraf}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

  </div>
);

export default TrabzonTarihiPage;
